<template>
    <Button
        color="carbon-400"
        interfaceTarget="game-back-button"
        :class="$style.back_button_override"
        @click="emit('closeGame')"
    >
        <Icon name="chevron-left" />
        <Typography
            size="m"
            type="label"
            accent
            :responsive="false"
        >
            {{ $tr('gameContainer.back') }}
        </Typography>
    </Button>
    <div :class="$style.panel_spacer" />
    <div :class="$style.panel_buttons">
        <FullscreenButton
            :isFullscreen="props.isFullscreen"
            @click="emit('toggleFullscreen')"
        />
    </div>
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import Button from '@/components_new/Buttons/Button.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'

import FullscreenButton from '../FullscreenButton.vue'

const props = defineProps<{
    isFullscreen: boolean
}>()

const emit = defineEmits<{
    toggleFullscreen: []
    closeGame: []
}>()

const loginButton = useTemplateRef('login-button')

defineExpose({
    showLoginTooltip: () => loginButton.value?.showTooltip(),
})
</script>

<style module>
.panel_spacer {
    flex-grow: 1;
    min-width: 8px;
}

.panel_buttons {
    display: flex;
    gap: 4px;
}

.back_button_override {
    padding: 13px 16px;
}
</style>
